import BaseTool from '@/components/geoview/tools/BaseTool'
import GeoObjectStore from '@/components/geoview/GeoObjectStore'

class Create extends BaseTool {
  skipReset = false

  async onClick (e) {
    let layerNames = []
    for (let layerId in this.mapHelper.layers) {
      if (!this.mapHelper.layers.hasOwnProperty(layerId)) {
        return
      }
      layerNames.push(this.mapHelper.layers[layerId].getLayerId())
    }
    let f = this.getMap().queryRenderedFeatures(e.point, { layers: layerNames })

    if (f.length === 0) {
      return
    }

    if (typeof this.mapHelper.onObjectsSelect === 'function') {
      if (GeoObjectStore.getObjects().length > 0) {
        this.skipReset = true
      }
      GeoObjectStore.add(f[0], f)
      this.getMap().setFeatureState({ source: f[0].source, id: f[0].id }, { selected: true })
      await this.mapHelper.onObjectsSelect(GeoObjectStore.getObjects())
    }
  }

  resetSelection () {
    if (this.skipReset) {
      this.skipReset = false
      return
    }
    const clickedObjects = GeoObjectStore.getClickedObjects()
    for (const clickedobject of clickedObjects) {
      if (this.getMap().getSource(clickedobject.source)) {
        this.getMap().setFeatureState({ source: clickedobject.source, id: clickedobject.id }, { selected: false })
      }
    }

    GeoObjectStore.reset()
  }
}

export default Create
